module.exports = __webpack_public_path__ + "img/banner_right_2x.53e25a6a.png";